export enum CompileFolder {
  FullFlex = "FullFlex",
  Pub = "Pub",
  Tags = "Tags"
}
